/**
 * A number input also changes its value on scroll and on Arrow Up / Arrow Down,
 * not just via the spinner arrows. On a till screen that means an amount or a
 * discount can be altered without anyone typing a digit.
 *
 * The arrows themselves are hidden in index.css; these listeners close the other
 * two routes. Installed once at startup so it covers every number input in the
 * app, including ones added later.
 */
function isNumberInput(element) {
  return Boolean(element) && element.tagName === 'INPUT' && element.type === 'number';
}

export function installNumberInputGuards() {
  // Drop focus instead of blocking the event, so the page still scrolls normally
  document.addEventListener(
    'wheel',
    () => {
      if (isNumberInput(document.activeElement)) {
        document.activeElement.blur();
      }
    },
    { passive: true }
  );

  document.addEventListener('keydown', (event) => {
    if ((event.key === 'ArrowUp' || event.key === 'ArrowDown') && isNumberInput(event.target)) {
      event.preventDefault();
    }
  });
}

export default installNumberInputGuards;
